import "../CSS/Bestuur.css";

function Bestuur() {
  return (
    <div className="bestuursoverzicht">
      <div className="bestuurslid">
        <img src="/Bestuur/NickFoncke.JPG" alt="Nick Foncke" />
        <p>
          <b>Nic Foncke</b>
          <br />
          Gerechtigd correspondent <br /> Secretaris
        </p>
      </div>
      <div className="bestuurslid">
        <img src="/Bestuur/HansDePoortere.JPG" alt="Hans De Poortere" />
        <p>
          <b>Hans De Poortere</b>
          <br />
          Bestuurslid
        </p>
      </div>
      <div className="bestuurslid">
        <img src="/Bestuur/KurtVerbrugge.JPG" alt="Kurt Verbrugge" />
        <p>
          <b>Kurt Verbrugge</b>
          <br />
          Bestuurslid
        </p>
      </div>
      <div className="bestuurslid">
        <img src="/Bestuur/RafClaerhout.JPG" alt="Raf Claerhout" />
        <p>
          <b>Raf Claerhout</b>
          <br />
          Bestuurslid
        </p>
      </div>
      <div className="bestuurslid">
        <img src="/Bestuur/HendrikWulteputte.JPG" alt="Hendrik Wulteputte" />
        <p>
          <b>Hendrik Wulteputte</b>
          <br />
          Bestuurslid
        </p>
      </div>
      <div className="bestuurslid">
        <img src="/Bestuur/LucCoene.jpg" alt="Luc Coene" />
        <p>
          <b>Luc Coene</b>
          <br />
          Bestuurslid
        </p>
      </div>
      <div className="bestuurslid2">
        <p>
          <b>Steven Feys</b>
          <br />
          Bestuurslid
        </p>
      </div>
    </div>
  );
}

export default Bestuur;
